import React from 'react';
import {observer} from "mobx-react-lite";
import {useStores} from "./hooks/useStores";
import {MidiPortsSelect} from "./components/MidiPortsSelect";
import {Modulator} from "./stores/Modulator";
import {GlobalTransport} from "./components/GlobalTransport";
import {Presets} from "./components/Presets";
import {ModulatorWrapper} from "./components/ModulatorWrapper";
import './App.css';
import {MidiSupportWarning} from "./components/MidiSupportWarning";

const App = observer(() => {

    // console.log("App render");

    const {modulatorsStore: modulators} = useStores();

    return (
        <div className="App">

            <MidiSupportWarning />

            <div className="header">
                <Presets />
                <GlobalTransport />
                <div className="about">
                    <div className="bold">Modulators</div>
                    <div>by&nbsp;<a href="https://studiocode.dev" target="_blank" rel="noopener noreferrer">StudioCode.dev</a></div>
                </div>
            </div>
            <main>
                <div className="row bg padded border-t border-b">
                    <MidiPortsSelect/>
                    {/*<MidiClockSelect/>*/}
                </div>
                {modulators.modulators.map((modulator: Modulator, index: number) =>
                <ModulatorWrapper key={index} modulator={modulator} index={index} />
                )}
                <div className="padded border-t w">
                    <button onClick={modulators.addModulator}>Add a Modulator</button>
                </div>
            </main>
            <footer>
                <div className="version">Version {process.env.REACT_APP_VERSION}</div>
                {/*<span className="beta-warning">BETA VERSION - SOME FEATURES NOT IMPLEMENTED OR INCOMPLETE</span>*/}
                <a href="https://studiocode.dev/doc/modulators/" target="_blank" rel="noopener noreferrer">Documentation</a>
            </footer>
        </div>
    );
});

export default App;
